import { useContext } from 'react';
import { Row, Col } from 'reactstrap';
import PopupNotificationFind from './PopupNotificationFind';
import LearningContext from '_helper/Leatning';

const PopupNotificationFilter = () => {
  const { isOpen, setIsOpen } = useContext(LearningContext);
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Col xl="3 xl-20">
      <div className="job-sidebar md-sidebar"><a className="btn btn-primary md-sidebar-toggle" href="#javascript" onClick={toggleSidebar}>Popup Notification Filter</a>
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen ? 'open' : ''}`}>
          <div className="default-according style-1 faq-accordion job-accordion" id="accordionoc">
            <Row>
              <PopupNotificationFind />
            </Row>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default PopupNotificationFilter;